import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
} from '@mui/material';
import {
  Layers,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';


// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données
const farmingData = {
  title: "Nombre de ménages agricoles pratiquant l'élevage des mouches, des escargots, des grenouilles et des vers de terre par province",
  species: ["Mouches", "Escargots", "Grenouilles", "Vers de terre"],
  provinces: [
    {
      name: "BUHUMUZA",
      mouches: "203",
      escargots: "113",
      grenouilles: "104",
      versDeTerre: "113",
      total: "416 068"
    },
    {
      name: "BUJUMBURA",
      mouches: "152",
      escargots: "66",
      grenouilles: "59",
      versDeTerre: "95",
      total: "461 754"
    },
    {
      name: "BURUNGA",
      mouches: "117",
      escargots: "74",
      grenouilles: "73",
      versDeTerre: "78",
      total: "411 362"
    },
    {
      name: "BUTANYERERA",
      mouches: "311",
      escargots: "104",
      grenouilles: "113",
      versDeTerre: "112",
      total: "552 250"
    },
    {
      name: "GITEGA",
      mouches: "150",
      escargots: "88",
      grenouilles: "89",
      versDeTerre: "92",
      total: "494 561"
    }
  ],
  total: {
    mouches: "933",
    escargots: "445",
    grenouilles: "438",
    versDeTerre: "490",
    total: "2 335 995"
  }
};

const InsectFarmingHouseholdsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Province\tMouches\tEscargots\tGrenouilles\tVers de terre\tTotal ménages\n";
    
    // Ajout des données totales
    tableContent += `BURUNDI\t${farmingData.total.mouches}\t${farmingData.total.escargots}\t${farmingData.total.grenouilles}\t${farmingData.total.versDeTerre}\t${farmingData.total.total}\n`;
    
    // Ajout des données par province
    farmingData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.mouches}\t${province.escargots}\t${province.grenouilles}\t${province.versDeTerre}\t${province.total}\n`;
    });
    
    navigator.clipboard.writeText(`${farmingData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données sur l'élevage des insectes et petits animaux au Burundi: ${farmingData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(farmingData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `elevage-insectes-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  // Fonction pour nettoyer et convertir les nombres
  const cleanNumber = (str) => {
    if (!str) return 0;
    return parseInt(str.toString().replace(/\s/g, '')) || 0;
  };

  // Calcul des indicateurs clés
  const keyStats = {
    totalHouseholds: farmingData.total.total,
    
    mostCommonSpecies: farmingData.species.reduce((max, species) => {
      const speciesKey = species.toLowerCase().replace(/\s/g, '');
      const currentTotal = cleanNumber(farmingData.total[speciesKey]);
      const maxTotal = cleanNumber(farmingData.total[max.toLowerCase().replace(/\s/g, '')]);
      return currentTotal > maxTotal ? species : max;
    }, farmingData.species[0]),
    
    provinceWithMostFarming: farmingData.provinces.reduce((max, province) => 
      cleanNumber(province.total) > cleanNumber(max.total) ? province : max
    , farmingData.provinces[0]),
    
    provinceWithLeastFarming: farmingData.provinces.reduce((min, province) => 
      cleanNumber(province.total) < cleanNumber(min.total) ? province : min
    , farmingData.provinces[0]),
    
    highestMouchePercentage: farmingData.provinces.reduce((max, province) => {
      const total = cleanNumber(province.total);
      const mouches = cleanNumber(province.mouches);
      const percentage = total > 0 ? (mouches / total) * 100 : 0;
      return percentage > max.percentage ? { province, percentage } : max;
    }, { province: farmingData.provinces[0], percentage: 0 }),
    
    highestEscargotPercentage: farmingData.provinces.reduce((max, province) => {
      const total = cleanNumber(province.total);
      const escargots = cleanNumber(province.escargots);
      const percentage = total > 0 ? (escargots / total) * 100 : 0;
      return percentage > max.percentage ? { province, percentage } : max;
    }, { province: farmingData.provinces[0], percentage: 0 })
  };

  const filteredProvinces = farmingData.provinces.filter(province =>
    !searchTerm || province.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {farmingData.title}
                    </Typography>
                  </Box>
                  <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6} ></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher province..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '480px' } }}
                      />
                    </Grid>
                  </Grid>
    
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés par Province
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ménages Agricoles Totaux
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {farmingData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                pratiquant l'élevage
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Espèce la plus commune
                              </Typography>
                              <Typography variant="h6" fontWeight="bold" textTransform="capitalize">
                                {keyStats.mostCommonSpecies.toLowerCase()}
                              </Typography>
                              <Typography variant="body1">
                                {farmingData.total[keyStats.mostCommonSpecies.toLowerCase().replace(/\s/g, '')]}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province avec plus d'élevage
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.provinceWithMostFarming.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.provinceWithMostFarming.total}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus forte proportion mouches
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestMouchePercentage.province.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.highestMouchePercentage.percentage.toFixed(1)}%
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des ménages agricoles pratiquant l'élevage">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province</TableCell>
                          {farmingData.species.map((species, index) => (
                            <TableCell key={index} align="right">{species}</TableCell>
                          ))}
                          <TableCell align="right">Total ménages agricoles</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          {farmingData.species.map((species, index) => (
                            <TableCell key={index} align="right" sx={{ fontWeight: 'bold' }}>
                              {farmingData.total[species.toLowerCase().replace(/\s/g, '')]}
                            </TableCell>
                          ))}
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{farmingData.total.total}</TableCell>
                        </ProvinceRow>

                        {/* Données par province */}
                        {filteredProvinces.map((province, index) => (
                          <ProvinceRow key={index} hover>
                            <TableCell component="th" scope="row">
                              {province.name}
                            </TableCell>
                            {farmingData.species.map((species, idx) => (
                              <TableCell key={idx} align="right">{province[species.toLowerCase().replace(/\s/g, '')]}</TableCell>
                            ))}
                            <TableCell align="right">{province.total}</TableCell>
                          </ProvinceRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                    {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos de l'élevage des insectes et petits animaux
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      L'élevage des insectes et petits animaux est une pratique agricole émergente au Burundi:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Mouches: élevées pour la production de farine animale" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Escargots: élevés pour leur chair et leur mucus cosmétique" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Grenouilles: élevées pour leur chair et leurs pattes" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Vers de terre: élevés pour le lombricompost et comme appât" 
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      Ces données représentent {farmingData.total.total} ménages agricoles au Burundi, 
                      avec une prédominance de l'élevage {keyStats.mostCommonSpecies.toLowerCase()} ({farmingData.total[keyStats.mostCommonSpecies.toLowerCase().replace(/\s/g, '')]} ménages).
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et de l'Elevage (RGPHAE) 
                    réalisé en 2024. Un ménage agricole est comptabilisé comme pratiquant l'élevage s'il possède au moins un animal 
                    d'une espèce donnée. Les chiffres représentent le nombre de ménages, pas le nombre d'animaux.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default InsectFarmingHouseholdsPage;